const YAxisLabel = props => {
  const { viewBox, value, offset } = props
  const { x, y, height, width } = viewBox
  // calc from CustomizedXAxisTick (dy + fontSize)
  const TICK_HEIGHT = 30
  const currentPos = {
    x: x + width / 2,
    y: y + height / 2 + TICK_HEIGHT + offset
  }

  return (
    <g
      transform={`translate(${currentPos.x},${currentPos.y})`}
    >
      <text
        dy={-4}
        fill='#979ba7'
        fontSize={12}
        textAnchor='middle'
      >
        {value}
      </text>
    </g>
  )
}

export default YAxisLabel
